import PropTypes from 'prop-types';
import React, { useCallback } from 'react';

import { LandingsPropTypes } from '@mssgme/ui';
import { useCRMData, useFrontAPI } from '../../../hooks';
import RobokassaButton from './Buttons/RobokassaButton';

const propTypes = {
    order: LandingsPropTypes.order.isRequired,
    disabled: PropTypes.bool,
};

export function RobokassaPayment({ order, disabled }) {
    const api = useFrontAPI();
    const {
        payments: {
            robokassa: { merchantLogin, test: isTest },
        },
    } = useCRMData();
    const createSignature = useCallback(
        (payload) => api.orders.signatures.createRobokassaSignature({ orderId: order._id, payload }),
        [order._id]
    );

    return (
        <RobokassaButton
            merchantLogin={merchantLogin}
            outSum={order.total.amount}
            outSumCurrency={order.total.currency}
            invId={order._id}
            createSignature={createSignature}
            disabled={disabled}
            isTest={isTest}
        />
    );
}

RobokassaPayment.propTypes = propTypes;
